import { ICacheStorage, CacheEntry } from './types'
import { IndexedDBCache } from './IndexedDBCache'

export type { ICacheStorage, CacheEntry } from './types'

let instance: ICacheStorage | null = null

export function getCacheStorage (): ICacheStorage {
  if (!instance) {
    instance = new IndexedDBCache()
  }
  return instance
}

/**
 * Get a cached value only if it's fresher than `maxAge` ms.
 * Returns null if missing or expired.
 */
export async function getCached<T = unknown> (
  key: string,
  maxAge?: number
): Promise<T | null> {
  const entry = await getCacheStorage().get<T>(key)
  if (!entry) return null
  if (maxAge && Date.now() - entry.timestamp > maxAge) return null
  return entry.value
}

/**
 * Cache a value with the given key.
 */
export async function setCached<T = unknown> (
  key: string,
  value: T
): Promise<void> {
  await getCacheStorage().set(key, value)
}
